import styled from 'styled-components';
import WhatsAppSelectedSVG from '../../assets/common/selected-wa.svg';

const WhatsAppSelectedIcon = styled(WhatsAppSelectedSVG as React.SFC<React.SVGProps<SVGSVGElement>>,)`
  width: ${props => props.width || '6rem'};
  height: ${props => props.height || '3.9rem'};
`;

export default WhatsAppSelectedIcon;
